/*
 * Cadwork webgl Engine
 * http://www.lexoview.com
 *
 * Copyright (C) 2015 Cadwork Informatik AG, Basel, Switzerland
 * Dual licensed under the MIT and GPL
 *
 * @author Jaroslav Přibyl (pribyl@cadwork.cz)
 *
 */

import Description from "App/model/description";

export default
abstract class AbstractMaterial {

    protected _UID: number = -1;
    protected id: number = null; // this member is set when the material is loaded from material library
    protected _classTypeName: string = null;
    protected _hashKey: string = null;
    protected _refCount: number = 0;

    protected constructor() {
        // uid is injected from factory
        this.id = null; // this member is set when the material is loaded from material library
        this._classTypeName = null;
        this._hashKey = null;

        this._refCount = 0;
    }

    public ref(): void {
        this._refCount++;
    }

    public unref(): void {
        this._refCount--;
    }

    public getRefCount(): number {
        return this._refCount;
    }

    public getUID(): number {
        return this._UID;
    }

    public getID(): number {
        return this.id;
    }

    public getClassTypeName(): string {
        return this._classTypeName;
    }

    public getHashKey(): string {
        return this._hashKey;
    }

    public parse(aModelDescription: Description, aJSON: any): void {
        // merge the data in the aBinaryGeometryProperties with the default values
        for (let property in aJSON) {
            this[property] = aJSON[property];
        }
    }

    public abstract match(aModelDescription: Description, aObject: any): boolean;

    public abstract getJSONRepresentation(): any;
}
